import { render, staticRenderFns } from "./DocumentTypeModal.vue?vue&type=template&id=7d87ac0f"
import script from "./DocumentTypeModal.vue?vue&type=script&lang=js"
export * from "./DocumentTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d87ac0f')) {
      api.createRecord('7d87ac0f', component.options)
    } else {
      api.reload('7d87ac0f', component.options)
    }
    module.hot.accept("./DocumentTypeModal.vue?vue&type=template&id=7d87ac0f", function () {
      api.rerender('7d87ac0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/DocumentTypeModal.vue"
export default component.exports